export default () => ({
  token: '',
  phone: '',
})
